import { SCALE_FACTOR as e } from "../../../config/globalConstants.js";
import { ScaleContext as t } from "../ScaleContext.js";
import { c as n } from "react/compiler-runtime";
import { useEffect as r, useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/Scale/ScaleProvider/ScaleProvider.tsx
var o = (o) => {
	let s = n(11), { children: c, initialScaleFactor: l, saveScaleFactor: u } = o, [d, f] = i(l === void 0 ? e : l), p;
	s[0] === u ? p = s[1] : (p = (e) => {
		u?.(e), f(e);
	}, s[0] = u, s[1] = p);
	let m = p, h, g;
	s[2] === d ? (h = s[3], g = s[4]) : (h = () => {
		document.documentElement.classList.toggle("scalingEnabled", d !== 1);
	}, g = [d], s[2] = d, s[3] = h, s[4] = g), r(h, g);
	let _;
	s[5] !== m || s[6] !== d ? (_ = {
		scaleFactor: d,
		onScaleChange: m
	}, s[5] = m, s[6] = d, s[7] = _) : _ = s[7];
	let v = _, y;
	return s[8] !== c || s[9] !== v ? (y = /* @__PURE__ */ a(t.Provider, {
		value: v,
		children: c
	}), s[8] = c, s[9] = v, s[10] = y) : y = s[10], y;
};
//#endregion
export { o as ScaleProvider };
